import React, { memo } from 'react';
import { Row, Col, Typography } from 'components';
import styles from './styles.module.scss';

interface PriceInfoProps {
  itemsPrice: number | string;
  deliveryCost: number | string;
  additionalFees: number | string;
  total: number | string;
  validityDate: string | undefined;
  formattedValidityDate?: string;
  leadTimeText: string;
  displayDate: (date: string) => string;
}

const { Text } = Typography;

export const PriceInfo: React.FC<PriceInfoProps> = memo(
  ({
    itemsPrice,
    deliveryCost,
    additionalFees,
    total,
    validityDate,
    formattedValidityDate,
    leadTimeText,
    displayDate,
  }) => {
    return (
      <Row>
        <Col span={12}>
          <div className={styles.priceRows}>
            <div className={styles.priceRow}>
              <Text type="secondary">Items</Text>
              <Text strong>{Math.ceil(+itemsPrice)}€</Text>
            </div>
            <div className={styles.priceRow}>
              <Text type="secondary">Delivery cost</Text>
              <Text strong>{Math.ceil(+deliveryCost)}€</Text>
            </div>
            <div className={styles.priceRow}>
              <Text type="secondary">Additional fees</Text>
              <Text strong>{Math.ceil(+additionalFees)}€</Text>
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div className={styles.totalSection}>
            <div className={styles.totalAmount}>{Math.ceil(+total)}€</div>
            <div className={styles.validUntil}>
              Valid until: {formattedValidityDate || (validityDate ? displayDate(validityDate) : '-')}
            </div>
            <div className={styles.leadTime}>{leadTimeText}</div>
          </div>
        </Col>
      </Row>
    );
  }
);
